import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", { d: "M10.47 15.53c.14.14.33.22.53.22h.04c.21-.01.41-.11.54-.27l5-6c.26-.32.22-.8-.1-1.06a.758.758 0 0 0-1.06.1l-4.47 5.37-2.42-2.42a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l3 3Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12 2.25a9.75 9.75 0 1 0 0 19.5 9.75 9.75 0 0 0 0-19.5ZM8.843 4.378a8.25 8.25 0 1 1 6.314 15.244A8.25 8.25 0 0 1 8.843 4.378Z",
  "clip-rule": "evenodd"
}, null, -1), s = [
  l,
  n
];
function d(r, a) {
  return t(), o("svg", c, [...s]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
